import createAction from '../../../../utils/redux-helpers/createAction';

const handler = (state, { data }) => state.set('selectedDriver', data);

export const setDriver = createAction({
  action: ['setDriver', 'data'],
  handler,
});
